import { Routes } from '../utils/constants/routes';
import Axios from 'axios';
import { LocalKeys } from './constants';

export const ROUTES_WITHOUT_HEADER = [Routes.LOGIN];

export const ALLOWED_ROUTES_TO_ROLES_MAP: any = {
    ROLE_USER: [Routes.ROOT, Routes.DASHBOARD, Routes.REQUESTER_ROUTES.ROOT, Routes.REQUESTER_ROUTES.REQUEST, Routes.REQUESTER_ROUTES.REQUEST_BY_ID],
    ROLE_ADMIN: [Routes.ROOT, Routes.DASHBOARD, Routes.REQUESTER_ROUTES.ROOT, Routes.REQUESTER_ROUTES.REQUEST, Routes.REQUESTER_ROUTES.REQUEST_BY_ID],
    ROLE_MODERATOR: [Routes.ROOT, Routes.DASHBOARD, Routes.REQUESTER_ROUTES.ROOT, Routes.REQUESTER_ROUTES.REQUEST, Routes.REQUESTER_ROUTES.REQUEST_BY_ID],
    ROLE_REQUESTER: [Routes.ROOT, Routes.DASHBOARD, Routes.REQUESTER_ROUTES.ROOT, Routes.REQUESTER_ROUTES.REQUEST, Routes.REQUESTER_ROUTES.REQUEST_BY_ID],
    ROLE_OPS: [Routes.DASHBOARD, Routes.OPS_ROUTES.ROOT, Routes.OPS_ROUTES.REQUEST, Routes.OPS_ROUTES.REQUEST_BY_ID]
};

export const generateAllowedRoutesForUser = (roles: string[] | undefined) => {
    const allowedRoutes: string[] = [];
    if (roles) {
        roles.forEach((role: any) => {
            allowedRoutes.push(ALLOWED_ROUTES_TO_ROLES_MAP[role]);
        });
        // returns array of unique routes that are allowed
        return [...Array.from(new Set(...allowedRoutes))];
    }
    return allowedRoutes;
};

export const canUserRoleAccessRoute = (allowedRoutes: string[], checkRoute: string) => {
    return allowedRoutes.includes(checkRoute);
};

export const updateTokenForPersistnce = (token: string) => {
    localStorage.setItem('token', token);
    Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const clearAndHandleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
};

export const setLocalActiveRole = (role: string) => {
    localStorage.setItem(LocalKeys.activeRole, role);
};

export const getLocalActiveRole = () => {
    return localStorage.getItem(LocalKeys.activeRole);
};
